import React, { useEffect, useRef } from 'react';
import $ from 'jquery';
import { useTranslation } from 'react-i18next';
import Button from "../../common/Button";

window.jQuery = $;
window.$ = $;

require('jquery-ui-sortable');
require('formBuilder');

const FormBuilderComponent = ({ formData, onFormSave, isTemplate = false, handleDiscardModal }) => {
  const fbRef = useRef(null);
  const formBuilderInstance = useRef(null);
  const [t] = useTranslation();

  useEffect(() => {
    if (fbRef.current && !formBuilderInstance.current) {
    console.log("------formdata------------", fbRef.current, formBuilderInstance.current, formData);
      fbRef.current.innerHTML = '';
      formBuilderInstance.current = $(fbRef.current).formBuilder({ formData});
    }
  }, [formData]);

  useEffect(() => {
    if (isTemplate) {
      fbRef.current.innerHTML = '';
      formBuilderInstance.current = $(fbRef.current).formBuilder({ formData});
    }
  }, [isTemplate, formData]);

  const saveForm = () => {
    if (formBuilderInstance.current) {
      const formJsonData = formBuilderInstance.current.actions.getData('json');
      onFormSave(formJsonData);
    }
  };

  return (
    <div>
      <div id="fb-editor" ref={fbRef} />
      <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '50px'}}>
        <Button
					color="primary"
          onClick={handleDiscardModal}
					style={{
						padding: "12px 22px",
						width: "157px",
            height: '40px',
            marginRight: '24px',
					}}
          text={t("Discard")}
				/>

        <Button
					color="primary"
          onClick={saveForm}
					style={{
						padding: "12px 22px",
						width: "157px",
            height: '40px',
					}}
          text={t("Save")}
				/>
      </div>
    </div>
  );
};

export default FormBuilderComponent;